import { render } from "./QuestionCard.vue?vue&type=template&id=76ee0da3&scoped=true"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"

import "./QuestionCard.vue?vue&type=style&index=0&id=76ee0da3&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ee0da3"]])

export default __exports__